/**
 * 筹码复盘排序分 V1（chipReviewScore）
 * 仅用于复盘展示/筛选，不参与综合分、星标、买入。
 * 12 档映射冻结，禁止自行改分。
 */

export const CHIP_REVIEW_SCORE_VERSION = 'V1'

/** chipV2Score|pricePositionLevel → chipReviewScore */
export const CHIP_REVIEW_SCORE_TABLE_V1 = Object.freeze({
  '90|MODERATE_BREAKOUT': 100,
  '70|MODERATE_BREAKOUT': 88,
  '90|NEUTRAL': 78,
  '70|NEUTRAL': 68,
  '70|HIGH': 58,
  '90|HIGH': 52,
  '50|MODERATE_BREAKOUT': 46,
  '50|NEUTRAL': 40,
  '50|HIGH': 32,
  '50|OVEREXTENDED': 22,
  '70|OVEREXTENDED': 18,
  '90|OVEREXTENDED': 12
})

/** 与线上 Chip V2 价格位置阈值一致（禁止修改） */
export const CHIP_REVIEW_PRICE_NEUTRAL_LT = 0.0215
export const CHIP_REVIEW_PRICE_MODERATE_LE = 0.1074
export const CHIP_REVIEW_PRICE_HIGH_LE = 0.1403

export const CHIP_REVIEW_TIER_KEYS = Object.freeze(['S+', 'S', 'A', 'B'])

export const CHIP_REVIEW_TIER_BUTTONS = Object.freeze([
  { key: 'ALL', label: '全部' },
  { key: 'S+', label: '✦ S+' },
  { key: 'S', label: 'S' },
  { key: 'A', label: 'A' },
  { key: 'B', label: 'B' }
])

/**
 * @param {number|null|undefined} priceToMax
 * @returns {'NEUTRAL'|'MODERATE_BREAKOUT'|'HIGH'|'OVEREXTENDED'|null}
 */
export function resolvePricePositionLevelForReview(priceToMax) {
  if (priceToMax == null || priceToMax === '') return null
  const p = Number(priceToMax)
  if (!Number.isFinite(p)) return null
  if (p < CHIP_REVIEW_PRICE_NEUTRAL_LT) return 'NEUTRAL'
  if (p <= CHIP_REVIEW_PRICE_MODERATE_LE) return 'MODERATE_BREAKOUT'
  if (p <= CHIP_REVIEW_PRICE_HIGH_LE) return 'HIGH'
  return 'OVEREXTENDED'
}

/**
 * @param {number|string|null|undefined} chipV2Score
 * @param {string|null|undefined} pricePosition level 或可解析的 level
 * @param {number|null|undefined} [priceToMax] level 缺失时回退解析
 * @returns {number|null}
 */
export function calcChipReviewScoreV1(chipV2Score, pricePosition, priceToMax = null) {
  const chip = Number(chipV2Score)
  if (chip !== 90 && chip !== 70 && chip !== 50) return null

  let level = pricePosition || null
  if (
    level !== 'NEUTRAL' &&
    level !== 'MODERATE_BREAKOUT' &&
    level !== 'HIGH' &&
    level !== 'OVEREXTENDED'
  ) {
    level = resolvePricePositionLevelForReview(priceToMax)
  }
  if (!level) return null

  const score = CHIP_REVIEW_SCORE_TABLE_V1[`${chip}|${level}`]
  return score == null ? null : score
}

/**
 * @param {number|null|undefined} chipReviewScore
 * @returns {'S+'|'S'|'A'|'B'|null}
 */
export function getChipReviewTier(chipReviewScore) {
  if (chipReviewScore == null || chipReviewScore === '') return null
  const s = Number(chipReviewScore)
  if (!Number.isFinite(s)) return null
  if (s === 100) return 'S+'
  if (s === 88) return 'S'
  if (s === 78) return 'A'
  if (s <= 68) return 'B'
  return null
}

/**
 * 给行对象写入 chipReviewScore / chipReviewTier（不写库）。
 * @param {object} row
 * @returns {object} 同一引用
 */
export function attachChipReviewScoreV1(row) {
  if (!row || typeof row !== 'object') return row
  const score = calcChipReviewScoreV1(row.chipV2Score, row.pricePositionLevel, row.priceToMax)
  row.chipReviewScore = score
  row.chipReviewTier = getChipReviewTier(score)
  return row
}

/**
 * 多选梯队 OR；空数组 = 全部（不过滤）。
 * 缺失 tier 永不命中任一梯队。
 */
export function passesChipReviewTierFilter(rowOrTier, selectedTiers) {
  const tiers = Array.isArray(selectedTiers) ? selectedTiers.filter(Boolean) : []
  if (!tiers.length) return true
  const tier =
    rowOrTier && typeof rowOrTier === 'object'
      ? rowOrTier.chipReviewTier != null
        ? rowOrTier.chipReviewTier
        : getChipReviewTier(
            rowOrTier.chipReviewScore != null
              ? rowOrTier.chipReviewScore
              : calcChipReviewScoreV1(
                  rowOrTier.chipV2Score,
                  rowOrTier.pricePositionLevel,
                  rowOrTier.priceToMax
                )
          )
      : rowOrTier
  if (tier == null) return false
  return tiers.includes(tier)
}
